// GoogleMapsProvider.jsx
import { useJsApiLoader } from "@react-google-maps/api";

const libraries = ["places"]; // ✅ constant declared outside to avoid array recreation

export default function GoogleMapsProvider({ children }) {
  const { isLoaded, loadError } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: import.meta.env.VITE_GOOGLE_PLACES_API_KEY,
    libraries, // ✅ stable array reference
    version: "weekly", // Use stable weekly version
  });

  if (loadError) return <div>Error loading Google Maps</div>;

  if (
    !isLoaded ||
    typeof window === "undefined" ||
    typeof window.google === "undefined" ||
    !window.google.maps
  ) {
    return <div>Loading Google Maps...</div>;
  }

  return children;
}
